module.exports = __webpack_public_path__ + "img/btn_lg_sign-up.8d701de.png";